import { ICON_TYPE, OzIcon } from '@omaze/omaze-ui';
import React, { ReactElement } from 'react';

import { FooterTestIds } from '../FooterTestIds';

import styles from './SocialIcons.module.css';

interface ISocialIcon {
    href: string;
    type: ICON_TYPE;
    dataTestId: FooterTestIds;
    className: string;
}

const socialIcons: ISocialIcon[] = [
    {
        href: 'https://facebook.com/omaze',
        type: ICON_TYPE.OZ_FACEBOOK,
        dataTestId: FooterTestIds.FACEBOOK_ICON,
        className: styles.facebook,
    },
    {
        href: 'https://instagram.com/omaze',
        type: ICON_TYPE.OZ_INSTAGRAM,
        dataTestId: FooterTestIds.INSTAGRAM_ICON,
        className: styles.instagram,
    },
    {
        href: 'https://youtube.com/user/teamomaze',
        type: ICON_TYPE.OZ_YOUTUBE,
        dataTestId: FooterTestIds.YOUTUBE_ICON,
        className: styles.youtube,
    },
    {
        href: 'https://twitter.com/omaze',
        type: ICON_TYPE.OZ_TWITTER,
        dataTestId: FooterTestIds.TWITTER_ICON,
        className: styles.twitter,
    },
    {
        href: 'https://tiktok.com/@omazeofficial',
        type: ICON_TYPE.OZ_TIKTOK,
        dataTestId: FooterTestIds.TIKTOK_ICON,
        className: styles.tiktok,
    },
];

export function SocialIcons (): ReactElement {

    return (
        <div className="flex mb-4">
            {
                socialIcons.map((icon: ISocialIcon): ReactElement => {
                    const { href, type, dataTestId, className }: ISocialIcon = icon;

                    return (
                        <a
                            key={href}
                            href={href}
                            className="w-4 h-4 bg-white hover:bg-rebrand-yellow-500 rounded-full flex justify-center mr-3 items-center"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <div className={className}>
                                <OzIcon className="h-full" type={type} data-testid={dataTestId} />
                            </div>
                        </a>
                    );
                })
            }
        </div>
    );
}
